import Vue from "vue"
import VueRouter from "vue-router"

// 引入组件

import login from '../page/login.vue'//首页
import home from '../page/home.vue'//店务系统
import RMBrand from '../page/RMBrand.vue'//品牌案例
import RMBrand_Details from '../page/RMBrand_Details.vue' //品牌案例详情
import notFound from '../page/404.vue'
import supplyChain from '../page/supplyChain.vue'//供应链
import marketingTools from '../page/marketingTools.vue'//营销工具
import company from '../page/company.vue'//公司简介
import channels from '../page/channels.vue'//渠道合作
import culture  from '../page/culture.vue'//发展历程、文化
import moreShop from '../page/moreShop.vue'//更多商家
import contact from '../page/contact.vue'//招聘、资讯
import school from '../page/school.vue'//找美商学院-学院文化
import Travell from '../page/Travell.vue'//美服在线商学院-行程安排
import Ali from '../page/Ali.vue'//美服在线商学院-走进阿里
// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);


//hidden 是否要渲染在左侧
//none 是否有子模块 
//
let routes = [
  {
    path: "/",
    redirect: '/login',
    hidden: true
  },
  {
    path: '/login',
    component: login,
    name: '',
    hidden: true
  },
  {
    path: '/home',
    component: home,
    name: '',
    hidden: true
  },
  {
      path:'/RMBrand',
      component:RMBrand,
      name:"",
      hidden:true
  },
  {
        path:'/RMBrand_Details',
        component:RMBrand_Details,
        name:"",
        hidden:true
    },
  {
    path: '/supplyChain',
    component: supplyChain,
    name: '',
    hidden: true
  },
  {
    path: '/marketingTools',
    component: marketingTools,
    name: '',
    hidden: true
  },
  {
    path: '/company',
    component: company,
    name: '',
    hidden: true
  },
  {
    path: '/channels',
    component: channels,
    name: '',
    hidden: true
  },
  {
    path: '/culture',
    component: culture,
    name: '',
    hidden: true
  },
  {
    path: '/moreShop',
    component: moreShop,
    name: '',
    hidden: true
  },
  {
    path: '/contact',
    component: contact,
    name: '',
    hidden: true
  },
  {
    path:'/school',
    component:school,
    name:'',
    hidden:true
  },
  {
    path:'/Travell',
    component:Travell,
    name:'',
    hidden:true
  },
  {
    path:'/Ali',
    component:Ali,
    name:'',
    hidden:true
  },








  {
    path: '/404',
    component: notFound,
    name: '',
    hidden: true
  },

  



];
var router = new VueRouter({
  routes
})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js